import React, { useMemo, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/free-mode";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchGalleries } from "../../redux/slices/galleriesSlice";
import './Gallery.css';

const GallerySwiper = () => {
  const { t, i18n } = useTranslation('global');
  const dispatch = useDispatch();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const isRTL = i18n.language === "ar";
  const swiperKey = useMemo(() => `swiper-${i18n.language}`, [i18n.language]);

  const { data: images, isLoading, error } = useSelector((state) => state.galleries);

  useEffect(() => {
    dispatch(fetchGalleries());
  }, [dispatch]);

  return (
    <div className="container py-4">
      <h3 className="sub-color title text-center mt-2 mb-4">
        {t("navbar.gallery")} <img src="/picture.gif" alt={t("navbar.gallery")} />
      </h3>

      {isLoading ? (
        <p className="text-center">{t("loading")}...</p>
      ) : error ? (
        <p className="text-danger text-center">{error}</p>
      ) : (
        <div dir={isRTL ? "rtl" : "ltr"} id="gallery" className="gallery">
          
          {/* Main Swiper */}
          <Swiper
            key={swiperKey}
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            spaceBetween={10}
            navigation={true}
            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
            modules={[Navigation, Thumbs, FreeMode]}
            className="mainSwiper mb-3"
            dir={isRTL ? "rtl" : "ltr"}
          >
            {images.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={img.image}
                  alt={`slide-${index}`}
                  style={{
                    width: "100%",
                    maxHeight: "450px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Thumbnail Swiper */}
          <Swiper
            onSwiper={setThumbsSwiper}
            spaceBetween={10}
            slidesPerView={4}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[Thumbs, FreeMode]}
            className="thumbSwiper"
            breakpoints={{
              320: { slidesPerView: 2 },
              576: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
            }}
          >
            {images.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={img.image}
                  alt={`thumb-${index}`}
                  style={{
                    height: "80px",
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "5px",
                    cursor: "pointer",
                    opacity: 0.6,
                  }}
                  className="img-thumbnail"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
};

export default GallerySwiper;
